<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="شكر-وتقدير">
<h1><span dir="rtl">شكر وتقدير</span></h1>
<p><span dir="rtl">الشكر لله الذي مكَّنِّي مِن إنجاز هذا العمل..</span></p>
<p><span dir="rtl">شكرًا لذاتي التي تسعى لاستراق الوقت مِن زحمة الحياة..</span></p>
<p><span dir="rtl">شكرًا لأوستن ماكولي لجهودهم ومساندتهم لي.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch004.vue?7e465183